import { Component, OnInit, Output, EventEmitter, TemplateRef, Input, SecurityContext } from '@angular/core';
import { PHBHPFeaturePackageElearningService } from "../ph-bhp-feature-package-elearning.service";
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-manageelearning',
  templateUrl: './ph-bhp-manageelearning.component.html',
  styleUrls: ['./ph-bhp-manageelearning.component.css']
})
export class PHBHPManageelearningComponent implements OnInit {
  tutorialDetails: any[];
  fileurl: any;
  filetype: any;
  filetitle;
  customClass;
  modalRef: BsModalRef;
  @Input() isDesktop: boolean;
  @Output() childData = new EventEmitter();
  subscription: Subscription
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(private service: PHBHPFeaturePackageElearningService,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
    public layoutService: PHBHPLayoutPackageService) { }

  config = {
    class: 'modal-full pdfFullview'
  };

  ngOnInit() {
    this.getTutorials();
    this.subscription = this.layoutService.lang.asObservable().subscribe(() => {
      this.getTutorials();
    })
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe()
  }

  getTutorials() {
    this.layoutService.showLoader = true;
    this.service.getTutorials().subscribe((res: any[]) => {
      this.layoutService.showLoader = false;
      var language = localStorage.getItem('selectedlanguage');
      var validLanguages = [];
      if (language == 'de') {
        validLanguages = ['de'];
      } else {
        validLanguages = [localStorage.getItem('selectedlanguage')];
      }

      this.tutorialDetails = res.filter(x => validLanguages.includes(x.language));
    });
  }

  backToManageTutorials(): void {
    this.childData.emit('elearning');
  }

  openModal(template: TemplateRef<any>, fileURL, fileType, filetitle) {
    this.filetype = fileType;
    this.filetitle = filetitle;
    if (fileType === 'pdf') {
      fileURL = fileURL + '#toolbar=0';
      this.customClass = 'pdfModal modal-full pdfFullview';
    } else {
      this.customClass = 'vedioModal modal-full pdfFullview';
    }
    //this.fileurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizer.sanitize(SecurityContext.URL,this.data.serverUrl + fileURL));
    this.fileurl = this.layoutService.serverUrl + fileURL
    if (this.isDesktop) {
      this.modalRef = this.modalService.show(template, Object.assign({}, this.config, { class: this.customClass }));
    } else {
      this.childData.emit({ event: 'openModal', url: this.fileurl, fileType: this.filetype, title: filetitle });
    }
  }
}
